import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { login } from "../lib/api";
import { isLoggedIn, saveSession, takeLoginMessage } from "../lib/auth";
import { useDocumentTitle } from "../lib/hooks";
import { Button, Field, Input, Spinner } from "../ui";
import logo from "../styles/preascent-logo.png";

export default function Login() {
    useDocumentTitle("Sign in");
    const history = useHistory();
    const location = useLocation();
    const [u, setU] = useState("");
    const [p, setP] = useState("");
    const [show, setShow] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(() => takeLoginMessage());
    const uRef = useRef(null);
    const pRef = useRef(null);
    const from = (location.state && location.state.from && location.state.from.pathname) || "/today";

    useEffect(() => {
        if (isLoggedIn()) history.replace(from);
        else if (uRef.current) uRef.current.focus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!u.trim()) {
            setError("Enter your username.");
            uRef.current.focus();
            return;
        }
        if (!p) {
            setError("Enter your password.");
            pRef.current.focus();
            return;
        }
        setBusy(true);
        setError(null);
        try {
            const res = await login(u.trim(), p);
            if (!res || !res.access_token) throw new Error("No token in the response.");
            saveSession(res.access_token);
            history.replace(from === "/login" ? "/today" : from);
        } catch (err) {
            setBusy(false);
            setError(err.status === 401 ? "Wrong username or password." : err.message);
        }
    };

    return (
        <div className="hz-app hz-login">
            <form className="hz-login-card" onSubmit={submit} noValidate>
                <img src={logo} alt="Preascent" />
                <h1>Sign in to Horus</h1>
                <p className="hz-muted" style={{ margin: "0 0 24px" }}>CRM, talent intelligence and content review.</p>
                {error && <div className="hz-alert hz-alert-danger" style={{ marginBottom: 16 }}>{error}</div>}
                <div className="hz-form-grid" style={{ gap: 16 }}>
                    <Field label="Username">
                        <Input ref={uRef} value={u} onChange={(e) => setU(e.target.value)} autoComplete="username" />
                    </Field>
                    <Field label="Password">
                        <div className="hz-pw">
                            <Input ref={pRef} type={show ? "text" : "password"} value={p} onChange={(e) => setP(e.target.value)} autoComplete="current-password" />
                            <button type="button" aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow((s) => !s)}>
                                <i className={show ? "ri-eye-off-line" : "ri-eye-line"}></i>
                            </button>
                        </div>
                    </Field>
                    <Button type="submit" variant="primary" block disabled={busy} style={{ padding: 10, fontSize: 14, fontWeight: 500, marginTop: 8 }}>
                        {busy && <Spinner />}
                        Sign in
                    </Button>
                </div>
            </form>
            <div className="hz-login-foot">© {new Date().getFullYear()} Preascent</div>
        </div>
    );
}
